const PAYOUTS_API_HOSTNAME = `${process.env.GATSBY_PAYOUTS_API_HOSTNAME}`;
const ACCOUNTS_HOSTNAME = `${process.env.GATSBY_ACCOUNTS_HOSTNAME}`;
const PAYOUTS_HOSTNAME = `${process.env.GATSBY_PAYOUTS_HOSTNAME}`;
const DOCUMENTATION_HOSTNAME = `${process.env.GATSBY_DOCUMENTATION_HOSTNAME}`;
const ACCOUNTS_API_HOSTNAME = `${process.env.GATSBY_ACCOUNTS_API_HOSTNAME}`;
const SUPPORT_REDIRECT_URL = `${process.env.GATSBY_SUPPORT_REDIRECT_URL}`;

const apiPaths = {
  signup: "users",
  contactUs: "contact-us",
  register: "users",
  generateEmailVerifyToken: "useremailtoken",
  login: "authenticate",
  verifyPasswordToken: "verifyuserpasswordreset",
  updatePassword: "updateuserpassword",
  forgotPasswordLink: "resetpassword",
  kycForm: "documentupload",
  payouts: "payouts",
  logout: "logout",
  user: "auth/user",
};

export {
  PAYOUTS_API_HOSTNAME,
  ACCOUNTS_HOSTNAME,
  PAYOUTS_HOSTNAME,
  DOCUMENTATION_HOSTNAME,
  ACCOUNTS_API_HOSTNAME,
  SUPPORT_REDIRECT_URL,
  apiPaths,
};
